exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circleFill-container{display:flex;justify-content:center;margin-top:3%}.circle{overflow:hidden;background-color:#d9d9d9;border-radius:100px;border-width:5px;border-color:var(--generic-black);width:180px;height:180px;display:flex;flex-direction:column;justify-content:flex-end}.circleFill{width:100%;background-color:var(--circle-fill-color);border-top-color:#aeaeae;border-top-width:0px;height:0%}.circleFillLogo{align-self:center;position:absolute;width:120px;height:auto;padding-bottom:30px}\n", ""]);

// exports
